<template>
  <v-container fluid fill-height>
    <v-layout align-center justify-center>
      <v-flex xs12 sm8 md6>
        <v-dialog v-model="recuperar_clave" persistent max-width="400">
          <v-form v-model="validFRecuperacionClave">
            <v-card>
              <v-toolbar color="primary" dark flat>
                <v-toolbar-title style="text-transform:uppercase">Recuperar Contraseña</v-toolbar-title>
                <v-spacer></v-spacer>
              </v-toolbar>
              <v-spacer></v-spacer>
              <v-card-text>
                <small>Por favor ingrese su correo y número de documento</small>
                <v-text-field
                  label="Correo electrónico"
                  name="email"
                  prepend-icon="mail"
                  type="email"
                  autocomplete="new-correo_electrónico"
                  #correo_electrónico
                  v-model="recuperacion_clave.email.campo"
                  :rules="emailRules"
                  :error-messages="errors.collect(`${recuperacion_clave.email.valido}`)"
                  required
                ></v-text-field>
              </v-card-text>
              <v-card-actions style="display:flex; justify-content: space-between">
                <v-btn
                  color="orange darken-1"
                  text
                  class="white--text estilo_dos_columnas"
                  style="width:180px"
                  @click="recuperar_clave = false"
                >Cancelar</v-btn>
                <v-btn
                  color="indigo darken-1"
                  text
                  class="white--text estilo_dos_columnas"
                  style="width:180px"
                  @click="recuperarClave"
                  :disabled="!validFRecuperacionClave"
                >Link de recuperación</v-btn>
              </v-card-actions>
            </v-card>
          </v-form>
        </v-dialog>

        <v-form method="POST" :action="url_action" v-model="validFAutenticacion">
          <input type="hidden" name="_token" :value="code_token" />
          <v-card class="elevation-12">
            <v-toolbar color="primary" dark flat>
              <v-toolbar-title style="text-transform:uppercase">Acceso Representantes</v-toolbar-title>
              <v-spacer></v-spacer>
            </v-toolbar>
            <v-card-text>
              <v-alert
                :value="true"
                type="info"
                class="text-justify"
              >Bienvenid@ al formulario en línea de presentación de observaciones a las Versiones Voluntarias de las víctimas acreditadas en al marco del Caso No. 01.</v-alert>
              <v-divider class="mx-1"></v-divider>
              <p class="text-center">
                <small class="text-uppercase">Por favor, digite su correo electrónico y contraseña.</small>
              </p>
              <v-text-field
                label="Correo electrónico"
                name="email"
                prepend-icon="mail"
                type="text"
                autocomplete="new-correo_electrónico"
                #correo_electrónico
                v-model="autenticacion.email.campo"
                :rules="emailRules"
                :error-messages="errors.collect(`${autenticacion.email.valido}`)"
                required
              ></v-text-field>
              <v-text-field
                label="Contraseña"
                name="password"
                id="password"
                prepend-icon="lock"
                autocomplete="new-password"
                #password
                type="password"
                v-model="autenticacion.password.campo"
                :rules="passwordRules"
                :error-messages="errors.collect(`${autenticacion.password.valido}`)"
                required
              ></v-text-field>
            </v-card-text>
            <v-spacer></v-spacer>
            <v-card-actions style="display:flex; justify-content: space-between">
              <v-btn
                color="orange darken-1"
                class="white--text estilo_dos_columnas"
                style="width:250px"
                @click="recuperar_clave = true"
              >Recuperar Contraseña</v-btn>
              <v-btn
                color="indigo darken-1"
                class="white--text estilo_dos_columnas"
                type="submit"
                style="width:250px"
                :disabled="!validFAutenticacion"
              >Ingresar</v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import { EventBus } from "../../../EventBus";
import Usuario from "../../../services/RepresentanteService";

export default {
  data: () => ({
    validFRecuperacionClave: false,
    recuperacion_clave: {
      email: { campo: "", valido: false }
    },
    validFAutenticacion: false,
    autenticacion: {
      email: { campo: "", valido: false },
      password: { campo: "", valido: false }
    },
    recuperar_clave: false,
    url_action: "/traslado/representantes/login",
    code_token: "",
    inputRules: [v => !!v || "Campo es requerido"],
    numberRules: [
      v => /^[0-9]{3,20}$/.test(v) || "Debe digitar sólo valores numéricos"
    ],
    emailRules: [
      v =>
        /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/.test(v) ||
        "Debe digitar un correo electrónico válido"
    ],
    passwordRules: [
      v =>
        /(?=^.{8,}$)((?=.*\d)(?=.*\W+))(?![.\n])(?=.*[A-Z])(?=.*[a-z]).*$/.test(v) ||
        "Digite mínimo 8: (Mayúsculas, minúsculas, numeros, carácteres especiales)"
    ]
  }),
  created() {
    this.initialize();
  },
  mounted() {
  },
  components: {},
  computed: {},
  watch: {},
  methods: {
    initialize() {
      this.obtenerToken();
    },
    obtenerToken() {
      this.code_token = document.getElementsByName("_token")[0].value;
    },
    recuperarClave() {
      let representante = {
        email: this.recuperacion_clave.email.campo
      };
      Usuario.solicitarLinkRecuperacionClave(representante).then(response => {
        console.log(response);
        this.recuperar_clave = false;
      });
    }
  }
};
</script>
<style lang="css" scoped>
.estilo_dos_columnas {
  width: 50%;
  margin-left: 5px;
  margin-top: 5px;
}
.estilo_tres_columnas {
  width: 33%;
  padding-right: 10px;
  padding-top: 15px;
}
</style>
